import { render, staticRenderFns } from "./DataImport.vue?vue&type=template&id=646b9730&"
import script from "./DataImport.vue?vue&type=script&lang=ts&"
export * from "./DataImport.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports